import { handleActions } from "redux-actions";

import { setSource } from "./actions";

const initialState = {
    isLoadingSource: false,
    sources: {},
    codes: []
};

export const sourceReducer = handleActions(
    {
        [setSource]: (state, { payload }) => ({
            ...state,
            ...payload
        })
    },
    initialState
);